const departments = [
    "Leadership",
    "Engineering",
    "Product",
    "Growth",
    "Customer",
    "Business Ops",
    "Data & Analytics",
    "IT & Security",
  ];
  
  const subDepartments = [
    "Frontend",
    "Backend",
    "Automation",
    "Integration",
    "QA",
    "DevOps",
    "AI",
  ];
  
  const Node = ({ label, color = "bg-gray-100" }) => (
    <div className={`px-3 py-2 rounded-xl text-xs text-center ${color} shadow-sm`}>
      {label}
    </div>
  );
  
  const Hierarchy = () => {
    return (
      <div className="bg-white rounded-xl shadow-sm p-4 h-full min-h-[260px]">
        
        <h3 className="text-sm font-semibold mb-4">
          Organization Structure
        </h3>
  
        {/* ROOT */}
        <div className="flex justify-center mb-6">
          <div className="bg-blue-100 text-blue-600 px-4 py-2 rounded-lg text-xs font-medium shadow-sm">
            AutoAppy
            <div className="text-[10px] text-gray-500">Root Organization</div>
          </div>
        </div>
  
        {/* LINE DOWN */}
        <div className="w-full flex justify-center">
          <div className="w-px h-6 bg-gray-300"></div>
        </div>
  
        {/* LEVEL 2 */}
        <div className="flex flex-wrap justify-center gap-3 relative mt-2">
          
          {/* horizontal line */}
          <div className="absolute top-0 left-0 right-0 h-px bg-gray-300"></div>
  
          {departments.map((dept) => (
            <div key={dept} className="flex flex-col items-center">
              
              {/* vertical line */}
              <div className="w-px h-4 bg-gray-300"></div>
  
              <Node label={dept} />
            </div>
          ))}
        </div>
  
        {/* LEVEL 3 */}
        <div className="flex flex-wrap justify-center gap-3 mt-6">
          {subDepartments.map((sub) => (
            <Node key={sub} label={sub} color="bg-green-100 text-green-700" />
          ))}
        </div>
  
      </div>
    );
  };
  
  export default Hierarchy;